import { getFID } from 'web-vitals/base';

const onFirstInputDelay = response => {
  getFID(fid => response(fid.value));
};

export default onFirstInputDelay;
